import * as FlashMessage from "../../shared/utils/flashMessage"
import { SUCCESS } from "../../shared/constants/messages.constants"
import { DYNAMIC_ROUTES } from "../../shared/constants/routes.constants";

export const onAssessmentCancelled = (data) => {
    window.location.href = DYNAMIC_ROUTES.ASSESSMENT(data.patientId)
    FlashMessage.success(SUCCESS.ASSESSMENT_SUCCESSFULLY_CANCELLED)
}